import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {QbTermsDto} from "../model/QbTermsDto";
import {DisposeBag} from "../modules/DisposeBag";

class QbTermsSelectController implements IComponentController {
    records: QbTermsDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllQbTerms(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.qbTermsSubscribeAndQuery().then(ret => {
            this.records = ret;
        });
    };

    $onInit(): void {
    }

    $onDestroy?() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.qbTermsSelect', [])
    .component('qbTermsSelect', {
        template: require('./QbTermsSelect.html'),
        controller: QbTermsSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
